module.exports = __webpack_public_path__ + "static/media/reverseparrot.c2763e6f.gif";